module.exports = __webpack_public_path__ + "static/media/westbury-bg.260e0a0a.jpg";